// https://github.com/react-qr-reader/react-qr-reader
// npm i react-qr-reader

import React, { useState } from 'react';

import { ViewFinder } from './ViewFinder';

import { QrReader } from 'react-qr-reader';

const QRCode = (props) => {
  // const [error, setError] = useState(null);
  // const [data, setData] = useState(null);

  let contWidth = 300;
  if (window.innerWidth > 1000) {
    contWidth = 900;
  } else if (window.innerWidth > 800) {
    contWidth = 700;
  } else if (window.innerWidth > 500) {
    contWidth = 450;
  }

  const styles = {
    container: {
      width: `${contWidth}px`,
      margin: 'auto',
    },
  };

  const args = {
    ViewFinder,
    videoId: 'video',
    scanDelay: 300,
    constraints: {
      facingMode: 'environment',
    },
    // videoStyle: {
    //   width: '600px',
    //   heigth: '600px'
    // }
  };

  return (
    <div style={styles.container}>
      <QrReader
        {
          ...args
        }
        onResult={(result, error) => {
          if (result) {            
            //setData( JSON.parse(result.text) );
            !!props.onSetData && props.onSetData( JSON.parse(result.text) );
          }

          if (error) {
            //setError(error.message);
            !!props.onSetError && props.onSetError( error );
          }
        }}
      />
      {/* <p>The value is: {JSON.stringify(data, null, 2)}</p>
      <p>The error is: {error}</p> */}
    </div>
  );
};

export default QRCode;

export const MockQRCode = (props) => {
  const json={ "created": "2021-05-14T10:35:00Z", "createdBy": "MGZ", "submittedBy": "christian.gebhard@mgz-muenchen.de", "phenopacketSchemaVersion": "2.0", "keyver": "0.1", "apiver": "1.0", "pseudonym": "HANSMOTKAMP", "payload": "-----BEGIN PGP MESSAGE-----\n\nwV4Dhx/ATfJT0nQSAQdAN61fj/MhSbDZcOh8nTqN53piJUuMeWyjR3oY8ns+\nAGYwcSwrGhrHx/bPhjrcAOk24/xgFdHx+613Tgn8QPv8y91jZANQv3GUhMGE\nayBgcF1E0sHOAWh1xWDyx4vtAxF5E+S8m1Em7rf1fQqnK6RP+/GmRLsbn/LI\nOR614v/OYWVXrgy4eSQOzJ9C52akjHoliCraVY5cZLl46Q+aak3PEGtJwIhF\ntjE+kcnjQN+XBobowkFxnzMp4Fh6Q/03XpPJX7zH7+/Zmpq/tdaQmIxtYpI6\nHbCB2EjiEKbvQ/IvZlrXl/Hhhc+TB1xMuPeSCQGhirr1npYpaW03cfU9A3XB\n86lKTbuP7iGs8P+mS6xTiAVN/8sodLmfFf1KvQjSCdDrakCYm9Vi1Xbh322l\njoLbmwAK4pwmqJbbBC1JD8qVU+S05RSZ372viWfs+ZA7avCC3FNeVbK920VO\nAJzof/+S4cykWJpRFVwuhknUY5nh5v6COQOf99DBV/n6Z6hM405sjiVYpJZn\nSSle4/TWRQIUt1NJVBBee4xhau2MwXH2B5trF/EOOwweHWh8/1veJP3x0Xow\n0BecTv1J/L7Zk6134FrdBfE6W2tXWO2Kjraz06FDn6fMoZAHDtboGgcLyYVd\nhERsDUawPBqkspYz/UZo9xsZEpzXPpM/zFht34CBAiEf/DlBqMDFBrdo44RO\nSYxPduSJUlA01ybEMXrNuzqPp22FN8w8MTVYxjZXipxmfvVFPIA0gLvkOBr0\nR49hkDfH4XBx84keMyk/XyIgdy6MM+SdfssLvQPO3TDJYGm1TE37nAbdok7E\nSYmC2rYbG51JMUux4hKiSF2p/jZ4IsiE99G3YO8pcWEmL27B3de7AxxGAoNB\nVmL7t0g3lMmoVS7uMF20j3IYyobhwxoU3Hpkt4gyyJjMvSVuvnBXD5pheg6H\nMjd00l2HuIPf29Hm5jhmLySPmJOmBfp7YnWu+AHJwuv0\n=QFM1\n-----END PGP MESSAGE-----\n" }
  props.onSetData( json );

  return <h1>Mock</h1>
};


// default styles: 
//   container: {
//     width: '100%',
//     paddingTop: '100%',
//     overflow: 'hidden',
//     position: 'relative',
//   },
//   video: {
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     display: 'block',
//     overflow: 'hidden',
//     position: 'absolute',
//     transform: undefined,
//   },
